// extracted by mini-css-extract-plugin
module.exports = {"container":"_2kuFv-QedQXrA6UXXm4b1K"};